import OurNewsPage from "./our-news-page";

export default OurNewsPage;